// export const API_BASE_URL = "http://localhost:4000/";
export const API_BASE_URL = "https://mr-reel.net/";

// Google reCAPTCHA keys (client-side)
export const RECAPTCHA_SITE_KEY = "6Ld_1bErAAAAAM_hLDH8Ngfg-MBbBkQcfCN0dI5K";
